const PROD_IMG_BUCKET = 'sch.prodimg'

const getCatalogImageUrl = (productId, thumbnail = true) => {
  return `https://s3.us-west-2.amazonaws.com/${PROD_IMG_BUCKET}/catalog/${
    thumbnail ? 'tn' : 'orig'
  }/${productId}.img`
}

export { getCatalogImageUrl }
